import React from 'react';
import { Card, CardContent, Box, Typography, Collapse } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { Button } from '@uplift/ui-v2';
import { Link } from 'react-router-dom';
import { L10nHTML, useL10n } from '@uplift/hooks';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { findPsychiatryRoute } from '@uplift/constants';
import { PsychAppointmentBookingSource } from '@uplift/api';


const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3),
  },
  icon: {
    color: '#D5D2C7',
    fontSize: '50px',
  },
  notMatchedReason: {
    '& a': {
      color: theme.palette.primary.main,
      '&:hover': {
        color: theme.palette.primary.dark
      },
      '&:visited': {
        color: theme.palette.primary.main
      },
      fontWeight: 600,
    }
  }
}));


export const NotMatchedWithPsychiatrist: React.VFC = () => {
  const l10n = useL10n();
  const { classes } = useStyles();

  const [ shown, setShown ] = React.useState(false);
  const arrowIcon = shown ? <KeyboardArrowUp fontSize="small" /> : <KeyboardArrowDown fontSize="small" />;

  return (
    <Card>
      <CardContent className={classes.root}>
        <Box>
          <AccountCircleOutlinedIcon className={classes.icon} fontSize="inherit" />
        </Box>
        <Box mt={2}>
          <Typography color="textSecondary" align="center" variant="h6">
            {l10n.rematching.notMatchedPsychiatrist.youAreNotMatched}
          </Typography>
        </Box>
        <Box mt={2}>
          <Typography color="textSecondary" align="center" variant="body2">
            {l10n.rematching.notMatchedPsychiatrist.description}
          </Typography>
        </Box>
        <Box mt={3}>
          <Button
            variant="contained"
            color="secondary"
            component={Link}
            to={findPsychiatryRoute.createLink(null, { source: PsychAppointmentBookingSource.clientCareTeamPage })}
          >
            {l10n.rematching.notMatchedPsychiatrist.findPsychiatrist}
          </Button>
        </Box>
        <Box mt={3}>
          <Button endIcon={arrowIcon} onClick={() => setShown(!shown)}>
            {l10n.rematching.notMatchedPsychiatrist.whyAmINotMatched}
          </Button>
        </Box>
        <Collapse in={shown}>
          {l10n.rematching.notMatchedPsychiatrist.whyAmINotMatchedReasons.map(reason => (
            <Box key={reason} pt={2}>
              <Typography className={classes.notMatchedReason}>
                <L10nHTML>
                  {reason}
                </L10nHTML>
              </Typography>
            </Box>
          )
          )}
        </Collapse>
      </CardContent>
    </Card>
  );
};
